import { checkResponse, get, post } from "@/utils/http"
import { APP_CONFIG } from '@/utils/constants'

export function requestExamCategory(id, page) {
  return get(`${APP_CONFIG.apiUrl}/exam/list?category_id=${id}&page=${page}`)
      .then(checkResponse)
}

export function requestExamList(data) {
  return get(`${APP_CONFIG.apiUrl}/exam`, data)
      .then(checkResponse)
}

export function requestExamInfo(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/info/${id}`)
      .then(checkResponse)
}

export function requestExamCombo(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/combo/${id}`)
      .then(checkResponse)
}

export function requestExamDetailBackup(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/detail/${id}`)
      .then(checkResponse)
}

export function requestExamDetail(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/${id}`)
      .then(checkResponse)
}

export function requestExamHistory(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/history/${id}`)
      .then(checkResponse)
}

export function requestExamTopScore(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/top_score?exam_id=${id}`)
      .then(checkResponse)
}

export function requestExamSubmit(id, data) {
  return post(`${APP_CONFIG.apiUrl}/exam/submit/${id}`, data)
      .then(checkResponse)
}

export function requestExamPurchase(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/purchase/${id}`)
      .then(checkResponse)
}

export function requestExamResponse(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/result/${id}`)
      .then(checkResponse)
}

export function requestExamDetailPreview(id) {
  return get(`${APP_CONFIG.apiUrl}/exam/${id}/preview`)
      .then(checkResponse)
}